var map = {
	"./62c0c9e40c8ce7b47fc70a4bc6e3692.jpg": 9263,
	"./686ba39c0d127cb50a151c471e2e602.jpg": 1662,
	"./大青沟净水厂.jpg": 4691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8952;